import { useContext } from "react";

import { ApiClientContext } from "@src/components";

function useApiClient() {
  return useContext(ApiClientContext);
}

export default useApiClient;
